import { render, staticRenderFns } from "./ClientesUpdate.vue?vue&type=template&id=2bf5a1b5&"
import script from "./ClientesUpdate.vue?vue&type=script&lang=js&"
export * from "./ClientesUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports